(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const buttonSelector = [
    'button',
    'input[type="button"]',
    'input[type="submit"]',
    'input[type="reset"]',
    'a.button',
    'a.hero-cta',
    'a.shop-all-btn',
    '.product-card__action a',
    '[role="button"]:not(#door-intro)',
    'summary'
  ].join(',');
  const primarySelector = [
    '.button',
    '.shopify-payment-button__button',
    '.hero-cta',
    '.shop-all-btn',
    '.modal-add-btn',
    '.survey-submit',
    '.survey-next',
    '.cart-checkout',
    '.cart-continue',
    '.promo-code-copy-btn',
    '.shopall-back',
    '.welcome-survey__continue',
    '.door-intro__enter',
    '.promo-copy-btn',
    '.subscribe-box button',
    '.newsletter-form button',
    '.product-card__action button',
    '.product-card__action a',
    '[type="submit"]'
  ].join(',');
  const compactSelector = [
    '.modal-close',
    '.survey-close',
    '.track-nav-btn',
    '.shopall-nav-btn',
    '.shopall-filter',
    '.modal-color-btn',
    '.product-hotspot',
    '.scene-hotspot',
    '.quantity-selector button',
    '.product-gallery__thumb',
    '.site-header__mobile summary',
    '.yab-mobile-nav summary',
    '[role="radio"]',
    '[role="tab"]'
  ].join(',');
  const existingMotionSelector = [
    '.product-hotspot',
    '.scene-hotspot',
    '.hotspot-dot',
    '.color-dot',
    '.modal-color-btn',
    '.shopall-card-swatch',
    '.product-card__swatch',
    '.card-color-dot',
    '.palette-option',
    '.survey-option',
    '.survey-float-btn',
    '[role="radio"]'
  ].join(',');

  function prepareButtonMotion(element) {
    if (!(element instanceof HTMLElement) || element.id === 'door-intro') return null;
    if (element.matches(existingMotionSelector)) return null;
    if (element.dataset.buttonMotionBound === 'true') return element;
    element.dataset.buttonMotionBound = 'true';
    element.classList.add('yab-button-motion');
    if (element.matches(compactSelector)) element.classList.add('yab-button-motion--compact');
    else if (element.matches(primarySelector)) element.classList.add('yab-button-motion--primary');
    else element.classList.add('yab-button-motion--compact');
    return element;
  }

  function initializeButtonMotion(scope = document) {
    if (scope instanceof Element && scope.matches(buttonSelector)) prepareButtonMotion(scope);
    scope.querySelectorAll?.(buttonSelector).forEach(prepareButtonMotion);
  }

  function motionButtonFromEvent(event) {
    const target = event.target instanceof Element ? event.target.closest(buttonSelector) : null;
    return target ? prepareButtonMotion(target) : null;
  }

  function initializeResponsiveMenus(scope = document) {
    scope.querySelectorAll('[data-responsive-menu]').forEach((details) => {
      if (details.dataset.responsiveMenuBound === 'true') return;
      details.dataset.responsiveMenuBound = 'true';
      const summary = details.querySelector('summary');
      const syncExpanded = () => summary?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      syncExpanded();
      details.addEventListener('toggle', syncExpanded);
      details.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => details.removeAttribute('open')));
      details.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        details.removeAttribute('open');
        summary?.focus();
      });
    });
  }

  initializeButtonMotion();
  initializeResponsiveMenus();
  document.addEventListener('shopify:section:load', (event) => {
    initializeButtonMotion(event.target);
    initializeResponsiveMenus(event.target);
  });

  const buttonObserver = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node instanceof Element) initializeButtonMotion(node);
    }));
  });
  buttonObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('pointermove', (event) => {
    const button = motionButtonFromEvent(event);
    if (!button || !button.classList.contains('yab-button-motion--primary') || button.classList.contains('mag-btn')) return;
    if (!finePointer.matches || reducedMotion.matches || button.matches(':disabled,[aria-disabled="true"]')) return;
    const rect = button.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width - .5) * Math.min(12, rect.width * .025);
    const y = ((event.clientY - rect.top) / rect.height - .5) * Math.min(8, rect.height * .12) - 2;
    button.style.setProperty('--yab-button-x', `${x.toFixed(2)}px`);
    button.style.setProperty('--yab-button-y', `${y.toFixed(2)}px`);
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    const button = motionButtonFromEvent(event);
    if (!button || (event.relatedTarget instanceof Node && button.contains(event.relatedTarget))) return;
    button.style.removeProperty('--yab-button-x');
    button.style.removeProperty('--yab-button-y');
    button.classList.remove('is-pressed');
  }, { passive: true });

  document.addEventListener('pointerdown', (event) => {
    const button = motionButtonFromEvent(event);
    if (button && !button.matches(':disabled,[aria-disabled="true"]')) button.classList.add('is-pressed');
    document.querySelectorAll('[data-responsive-menu][open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  ['pointerup', 'pointercancel'].forEach((eventName) => document.addEventListener(eventName, () => {
    document.querySelectorAll('.yab-button-motion.is-pressed').forEach((button) => button.classList.remove('is-pressed'));
  }, { passive: true }));
})();
